/* Maven — personalizacao da camisola.
   Mostra o dropdown dos jogadores ou as caixas do nome a medida, conforme a
   escolha feita no selector "Name & Number", realca o badge escolhido e
   escreve o nome e o numero por cima da fotografia das costas.              */
(function () {
  /* ------------------------------------------------------------------
     OS NOMES NAO SAO SEMPRE INGLESES — 21/08/2026
     Quando as traducoes entraram, a opcao `Badge` passou a chamar-se
     `Emblema` em portugues e `Insignia` em espanhol, e os valores passaram a
     `Sem emblema` / `1 emblema`. Este programa procurava as palavras
     inglesas: em vinte idiomas nao encontrava nada e a personalizacao
     desaparecia. Agora os nomes verdadeiros desta pagina chegam do snippet
     nos `data-`, e o ingles fica so como ultimo recurso.
     ------------------------------------------------------------------ */
  var CFG = {
    optNome: 'Name & Number',
    optBadge: 'Badge',
    valNome: ['None', 'Select player', 'Custom name'],
    valBadge: ['No Badge', '1 Badge', '2 Badges']
  };
  function lerCfg(raiz) {
    var d = raiz && raiz.dataset;
    if (!d) return;
    if (d.optNome) CFG.optNome = d.optNome;
    if (d.optBadge) CFG.optBadge = d.optBadge;
    if (d.valNome) CFG.valNome = d.valNome.split('||');
    if (d.valBadge) CFG.valBadge = d.valBadge.split('||');
  }
  /* Quantos emblemas leva este valor: e a posicao dele na lista da opcao —
     0 nenhum, 1 um, 2 dois — em vez de ler o numero do texto. */
  function contagemDoTexto(v) {
    var i = CFG.valBadge.indexOf(String(v == null ? '' : v));
    if (i >= 0) return i;
    var m = String(v || '').match(/^(\d+)\s/);
    return m ? parseInt(m[1], 10) : 0;
  }

  /* Ultima linha de defesa: no instante em que se carrega em «Adicionar ao
     carrinho», confirma-se que o campo dos emblemas tem os nomes. O tema le o
     formulario depois deste momento, por isso o que aqui se escrever ainda
     entra na encomenda. Nao se mexe na variante aqui — mexer faria o tema
     redesenhar o bloco a meio da compra. */
  var garantias = [];
  function garantirTudo() {
    for (var i = 0; i < garantias.length; i++) {
      try { garantias[i](); } catch (e) {}
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[name="add"], button[type="submit"]') : null;
    if (b && b.closest('form[action*="/cart/add"]')) garantirTudo();
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) garantirTudo();
  }, true);

  function valorDaOpcao(scope, nome) {
    var sel = scope.querySelector('select[name="options[' + nome + ']"]');
    if (sel) return sel.value;
    var radios = scope.querySelectorAll('input[type="radio"][name="' + nome + '"]');
    for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i].value;
    return '';
  }

  function limpar(input) {
    var v = input.value;
    if (input.dataset.mvnFiltro === 'numero') {
      v = v.replace(/[^0-9]/g, '').slice(0, 2);
    } else {
      v = v.replace(/[^A-Za-zÀ-ÿ .'-]/g, '').slice(0, 15).toUpperCase();
    }
    if (v !== input.value) input.value = v;
  }

  /* O preco de cada escolha do `Name & Number` escreve-se no proprio menu, e
     vem ja convertido do snippet (`data-preco-player` / `data-preco-custom`).
     Ate 19/08 estava no nome da opcao, em euros fixos, e nao acompanhava a
     moeda do pais. */
  function precosNoMenu(scope) {
    var caixa = scope.querySelector('.mvn-perso') || scope.closest('.mvn-perso');
    if (!caixa) return;
    var pp = caixa.dataset.precoPlayer, pc = caixa.dataset.precoCustom;
    var selects = document.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      var s = selects[i];
      for (var j = 0; j < s.options.length; j++) {
        var o = s.options[j];
        if (o.dataset.mvnPreco) continue;
        var t = o.textContent.trim();
        if (pp && t === CFG.valNome[1]) { o.textContent = t + ' (+' + pp + ')'; o.dataset.mvnPreco = '1'; }
        if (pc && t === CFG.valNome[2]) { o.textContent = t + ' (+' + pc + ')'; o.dataset.mvnPreco = '1'; }
      }
    }
  }

  /* ---------------------------------------------------- costas da camisola */

  /* A etiqueta do plantel vem como `SAKA 7` ou `M. SARR 22`: o numero e a
     ultima palavra, o resto e o nome que vai impresso. */
  function partirEtiqueta(txt) {
    var m = String(txt || '').trim().match(/^(.*?)\s+(\d{1,2})$/);
    return m ? { nome: m[1], numero: m[2] } : { nome: String(txt || '').trim(), numero: '' };
  }

  /* A fotografia grande da galeria, e nao a miniatura da barra de comprar:
     essa tambem tem o mesmo `alt` e estragava a posicao do nome. */
  function fotoDaGaleria(scope, sufixo, ficheiro) {
    /* Que legendas contam como frente e como costas. A loja tem as duas
       linguas: as camisolas de clube foram escritas em portugues
       ("Chelsea Home — costas") e as de seleccao em ingles ("... - back").
       19/08: a primeira versao desta regra so olhava para o ingles e as de
       clube deixaram de escrever o nome — foi o dono que deu por isso. */
    /* 21/08/2026 — esta lista tinha so ingles e portugues, de quando a loja
       tinha as duas linguas a mistura. Nesse mesmo dia as legendas passaram a
       ser traduzidas nas 18, e em alemao («- Ruckseite»), espanhol
       («- trasera»), japones («- バック») e mais treze **deixou de encontrar a
       fotografia das costas — e o nome nunca chegava a ser desenhado**.
       As palavras sao as mesmas do `legendas_termos.py`, que e quem escreve as
       legendas: se uma mudar la, tem de mudar aqui. */
    var COSTAS = ['back', 'costas', 'trasera', 'arrière', 'retro', 'rückseite',
                  'achterkant', 'tył', 'zadní strana', 'zadná strana', 'bagside',
                  'baksida', 'bakside', 'takapuoli', 'πίσω', 'hátulja', 'spate', 'バック'];
    var FRENTE = ['front', 'frente', 'delantera', 'avant', 'fronte', 'vorderseite',
                  'voorkant', 'przód', 'přední strana', 'predná strana', 'forside',
                  'framsida', 'etupuoli', 'μπροστά', 'eleje', 'față', 'フロント'];
    var palavras = sufixo === 'back' ? COSTAS : FRENTE;
    var fins = [];
    for (var t = 0; t < palavras.length; t++) {
      fins.push('- ' + palavras[t], '– ' + palavras[t], '— ' + palavras[t]);
    }

    function combina(img) {
      var a = (img.getAttribute('alt') || '').trim().toLowerCase().replace(/\s+view$/, '');
      for (var k = 0; k < fins.length; k++) if (a.slice(-fins[k].length) === fins[k]) return true;
      return false;
    }

    var galeria = document.querySelectorAll('.product-single__media img, .product-images__slide img');
    for (var i = 0; i < galeria.length; i++) {
      if (combina(galeria[i]) && galeria[i].closest('.product-single__media')) return galeria[i];
    }
    var solto = document.querySelector('.product-single__media img[src*="' + ficheiro + '"], ' +
                                       '.product-single__media img[data-srcset*="' + ficheiro + '"]');
    if (solto) return solto;

    /* Sem legenda nao se adivinha: **so se desenha o nome quando se sabe qual e
       a foto das costas.** Antes valia a ordem da galeria — a segunda foto era
       tida como as costas — e nas seleccoes isso e falso: no Panama a segunda
       era um modelo e no Mexico de manga comprida um grande plano da gola, e o
       numero saia por cima disso. Ordem do dono: sem foto das costas nao se
       escreve nada, mas a opcao de personalizar fica na mesma.
       A frente continua a valer pela ordem, que essa e sempre a primeira. */
    if (sufixo === 'back') return null;
    var todas = document.querySelectorAll('.product-single__media img');
    return todas.length ? todas[0] : null;
  }


  /* Onde e que a camisola esta dentro da fotografia. As de clube e as de
     seleccao vem enquadradas de maneira diferente, por isso mede-se em vez de
     adivinhar: o que nao for fundo branco e camisola. */
  var medidas = {};
  function medirCamisola(img, quandoPronto) {
    var fonte = img.currentSrc || img.src || '';
    if (!fonte) return;
    if (medidas[fonte]) { quandoPronto(medidas[fonte]); return; }
    var teste = new Image();
    teste.crossOrigin = 'anonymous';
    teste.onload = function () {
      try {
        var n = 120, c = document.createElement('canvas');
        c.width = c.height = n;
        var ctx = c.getContext('2d');
        ctx.drawImage(teste, 0, 0, n, n);
        var d = ctx.getImageData(0, 0, n, n).data;

        /* **Como se acha a camisola, mesmo quando ela e branca sobre fundo
           branco** (o caso do Sevilha, que punha o nome ao lado e pequeno):
           nao chega perguntar "isto e branco?". Faz-se ao contrario — o fundo
           e o que esta **agarrado a moldura da imagem** e nao tem contorno pelo
           meio. O contorno faz de parede: mede-se quanto a imagem muda de um
           ponto para o lado (o degrade), e onde muda muito a mancha do fundo
           para. O que o fundo nao alcancar e a camisola. */
        var cinza = new Float32Array(n * n);
        for (var i0 = 0; i0 < n * n; i0++) {
          cinza[i0] = 0.299 * d[i0 * 4] + 0.587 * d[i0 * 4 + 1] + 0.114 * d[i0 * 4 + 2];
        }
        var degrade = new Float32Array(n * n);
        for (var y2 = 1; y2 < n - 1; y2++) {
          for (var x2 = 1; x2 < n - 1; x2++) {
            var p = y2 * n + x2;
            degrade[p] = Math.abs(cinza[p + 1] - cinza[p - 1]) +
                         Math.abs(cinza[p + n] - cinza[p - n]);
          }
        }
        var cantos = [0, n - 1, (n - 1) * n, n * n - 1];
        var cr = 0, cg = 0, cb = 0;
        for (var c0 = 0; c0 < 4; c0++) {
          cr += d[cantos[c0] * 4]; cg += d[cantos[c0] * 4 + 1]; cb += d[cantos[c0] * 4 + 2];
        }
        cr /= 4; cg /= 4; cb /= 4;

        function mancha(tol, parede) {
          var fundo = new Uint8Array(n * n), fila = [];
          for (var b0 = 0; b0 < n; b0++) {
            fila.push(b0, (n - 1) * n + b0, b0 * n, b0 * n + n - 1);
          }
          while (fila.length) {
            var q = fila.pop();
            if (fundo[q]) continue;
            var k2 = q * 4;
            if (d[k2 + 3] > 40 &&
                (Math.abs(d[k2] - cr) + Math.abs(d[k2 + 1] - cg) + Math.abs(d[k2 + 2] - cb) > tol ||
                 degrade[q] > parede)) continue;
            fundo[q] = 1;
            var qx = q % n, qy = (q - qx) / n;
            if (qx > 0) fila.push(q - 1);
            if (qx < n - 1) fila.push(q + 1);
            if (qy > 0) fila.push(q - n);
            if (qy < n - 1) fila.push(q + n);
          }
          return fundo;
        }

        /* Tentam-se varias afinacoes, da parede mais firme para a mais frouxa.
           Uma camisola branca sobre fundo branco tem o contorno quase apagado:
           se a parede for frouxa, o fundo entra por baixo e fica-se so com os
           ombros — foi o que aconteceu no Sevilha, e por isso o numero saia
           pequeno e encostado a gola. A mancha so se aceita se **parecer uma
           camisola**: nem pequena nem a imagem toda, e tao alta quanto larga. */
        /* A parede boa depende da fotografia: numa foto limpa o fundo quase
           nao varia, noutra tem grao. Mede-se o barulho do proprio fundo (a
           faixa de tres pontos junto a moldura) e poe-se a parede um pouco
           acima dele. Sem isto, uma camisola branca sobre fundo branco ou
           deixava o fundo entrar por baixo, ou nao o deixava sair da moldura. */
        var barulho = [];
        for (var yb = 0; yb < n; yb++) {
          for (var xb = 0; xb < n; xb++) {
            if (xb > 2 && xb < n - 3 && yb > 2 && yb < n - 3) continue;
            barulho.push(degrade[yb * n + xb]);
          }
        }
        barulho.sort(function (p, q) { return p - q; });
        var ruido = barulho[Math.floor(barulho.length * 0.9)] || 0;
        var parede0 = Math.max(4, Math.round(ruido * 1.8));

        var fundo = null;
        var tentativas = [[30, parede0], [30, parede0 * 2], [36, 14], [60, 20], [90, 26]];
        for (var t0 = 0; t0 < tentativas.length; t0++) {
          var m0 = mancha(tentativas[t0][0], tentativas[t0][1]);
          var n0 = 0, ax0 = n, ay0 = n, ax1 = 0, ay1 = 0;
          for (var yy0 = 0; yy0 < n; yy0++) {
            for (var xx0 = 0; xx0 < n; xx0++) {
              if (m0[yy0 * n + xx0]) continue;
              n0++;
              if (xx0 < ax0) ax0 = xx0; if (xx0 > ax1) ax1 = xx0;
              if (yy0 < ay0) ay0 = yy0; if (yy0 > ay1) ay1 = yy0;
            }
          }
          var alt = (ay1 - ay0) + 1, larg = (ax1 - ax0) + 1;
          var feitio = larg > 0 ? alt / larg : 0;
          /* Nao se exige que a mancha venha cheia: numa camisola branca sobre
             fundo branco o fundo entra por baixo e o que sobra sao ilhas — os
             vivos das mangas, o emblema, a bainha. Mas as **beiras** dessas
             ilhas sao as beiras da camisola, e e isso que se quer. Por isso o
             que se exige e o **feitio**: tao alta quanto larga, e larga o
             suficiente para nao ser um logotipo perdido. */
          if (larg > 0.35 * n && alt > 0.35 * n && feitio > 0.72 && feitio < 1.7 &&
              n0 < 0.88 * n * n) {
            fundo = m0;
            break;
          }
        }

        var x0 = n, y0 = n, x1 = 0, y1 = 0, achou = false;
        for (var y = 0; y < n; y++) {
          for (var x = 0; x < n; x++) {
            var k = (y * n + x) * 4;
            var eTecido = fundo ? !fundo[y * n + x]
                                : (d[k + 3] > 40 && (d[k] < 238 || d[k + 1] < 238 || d[k + 2] < 238));
            if (eTecido) {
              achou = true;
              if (x < x0) x0 = x; if (x > x1) x1 = x;
              if (y < y0) y0 = y; if (y > y1) y1 = y;
            }
          }
        }
        if (!achou) return;
        /* O meio da camisola nao e o meio do rectangulo que a envolve: as
           mangas nem sempre saem iguais na fotografia e puxam o rectangulo
           para um lado. Mede-se linha a linha.

           **A armadilha das camisolas brancas:** numa camisola branca sobre
           fundo branco so se veem o emblema, o patrocinador e a gola, e uma
           linha do meio pode nao apanhar tecido nenhum — foi o que punha o
           nome ao lado na camisola do Sevilha. Por isso mede-se em varias
           alturas, deitam-se fora as linhas que apanham pouco, e fica a do
           meio. Se nenhuma servir, usa-se o rectangulo. */
        function linha(row) {
          var a = n, b = 0;
          for (var xx = 0; xx < n; xx++) {
            var kk = (row * n + xx) * 4;
            var tecido = fundo ? !fundo[row * n + xx]
                               : (d[kk + 3] > 40 && (d[kk] < 238 || d[kk + 1] < 238 || d[kk + 2] < 238));
            if (tecido) { if (xx < a) a = xx; if (xx > b) b = xx; }
          }
          return b > a ? [a, b] : null;
        }
        function mediana(v) {
          v.sort(function (p, q) { return p - q; });
          return v.length ? v[Math.floor(v.length / 2)] : null;
        }

        var largo = x1 - x0;
        var centros = [], troncoE = [], troncoD = [], pontasDir = [], pontasEsq = [];
        for (var f1 = 0.42; f1 <= 0.68; f1 += 0.04) {          // tronco
          var l1 = linha(Math.round(y0 + f1 * (y1 - y0)));
          if (l1 && (l1[1] - l1[0]) > 0.35 * largo) {
            centros.push((l1[0] + l1[1]) / 2);
            troncoE.push(l1[0]);
            troncoD.push(l1[1]);
          }
        }
        for (var f2 = 0.24; f2 <= 0.34; f2 += 0.025) {         // altura das mangas
          var l2 = linha(Math.round(y0 + f2 * (y1 - y0)));
          if (l2 && (l2[1] - l2[0]) > 0.6 * largo) { pontasDir.push(l2[1]); pontasEsq.push(l2[0]); }
        }
        /* **O centro da camisola, quando a medicao mente** (23/08).
           Reparo dele na Juventus de costas: o nome e o numero apareciam ~60 px
           a esquerda. A conta que os poe la esta certa; o que estava errado era
           este `centro` — dava **0,392** quando o centro verdadeiro e **0,495**.

           Porque: as costas da Juventus sao brancas sobre fundo branco, e as
           linhas do tronco (42%–68% da altura) agarram-se a sombra de um dos
           lados em vez do tecido. E o mesmo mal do Sevilha, mas a apanhar o
           centro em vez da largura.

           A guarda: **uma fotografia de produto e tirada com a camisola ao
           meio.** Entre a medida do tronco e a da silhueta inteira fica a que
           estiver mais perto do meio da fotografia, e no fim nunca se aceita
           mais de 6% de desvio. Um desvio maior do que isso e sempre erro de
           medicao, nunca a camisola. Nas fotografias que ja estavam certas
           (PSG: 1 px) isto nao muda nada — as duas medidas dao o mesmo. */
        var meioFoto = n / 2;
        var candidatos = [];
        var cTronco = mediana(centros);
        if (cTronco != null) candidatos.push(cTronco);
        candidatos.push((x0 + x1) / 2);
        candidatos.sort(function (p, q) {
          return Math.abs(p - meioFoto) - Math.abs(q - meioFoto);
        });
        /* Medido em seis clubes (Juventus, Arsenal, Milan, Real, Liverpool,
           Bayern): o centro da camisola na fotografia anda **sempre** entre
           0,487 e 0,500. Nunca sai dali. Por isso, se a medida cair fora dessa
           faixa, nao se limita — **deita-se fora e usa-se o meio da
           fotografia**, que e o valor certo em todas as que ja se mediram.
           Limitar so encostava o erro a beira da faixa (na Juventus dava 0,44,
           ainda 32 px ao lado); deitar fora acerta em cheio. */
        var centroPx = candidatos[0];
        var faixa = 0.025 * n;
        if (Math.abs(centroPx - meioFoto) > faixa) centroPx = meioFoto;
        var centro = centroPx / n;
        var pd = mediana(pontasDir), pe = mediana(pontasEsq);
        var td = mediana(troncoD), te = mediana(troncoE);

        /* **Onde acaba a manga e comeca o tronco: no sovaco.** Descendo a
           camisola, a largura cai de repente quando as mangas acabam — e essa
           queda que marca o sovaco. A linha logo abaixo dele da as beiras do
           tronco a altura certa (nao a da cintura, que numa camisola justa e
           bem mais estreita e punha o emblema meio fora da manga). */
        var alturas = [], largs = [], linhasM = [];
        for (var f4 = 0.18; f4 <= 0.60; f4 += 0.03) {
          var l4 = linha(Math.round(y0 + f4 * (y1 - y0)));
          alturas.push(f4);
          linhasM.push(l4);
          largs.push(l4 ? l4[1] - l4[0] : 0);
        }
        var iQueda = -1, queda = 0;
        for (var i4 = 1; i4 < largs.length; i4++) {
          var q4 = largs[i4 - 1] - largs[i4];
          if (q4 > queda) { queda = q4; iQueda = i4; }
        }
        if (iQueda > 0 && queda > 0.12 * largo && linhasM[iQueda]) {
          te = linhasM[iQueda][0];
          td = linhasM[iQueda][1];
        }

        /* **O meio da manga e entre a beira do tronco e a ponta da manga.** A
           beira do tronco mede-se mais abaixo, onde ja nao ha mangas, e serve
           de sovaco. Guarda-se tambem a largura de cada manga, para o emblema
           nunca sair maior do que ela. */
        var temD = (pd != null && td != null && pd > td);
        var temE = (pe != null && te != null && pe < te);
        // um pouco para dentro do meio: junto a ponta a manga estreita e o
        // emblema ficava com uma ponta sobre o fundo
        var mangaFotoDir = temD ? (td + 0.45 * (pd - td)) / n : (x0 + 0.88 * largo) / n;
        var mangaFotoEsq = temE ? (te - 0.45 * (te - pe)) / n : (x0 + 0.12 * largo) / n;
        var larguraMangaDir = temD ? (pd - td) / n : 0.12 * largo / n;
        var larguraMangaEsq = temE ? (te - pe) / n : 0.12 * largo / n;
        // as beiras da manga, para o emblema nunca sair de dentro dela
        var mangaDirDe = temD ? td / n : null, mangaDirAte = temD ? pd / n : null;
        var mangaEsqDe = temE ? pe / n : null, mangaEsqAte = temE ? te / n : null;

        /* **A altura da manga**, medida na propria manga: ha fotografias da
           camisola inteira e outras so do tronco, e uma percentagem fixa da
           altura punha o emblema ora no ombro ora na bainha. Olha-se para a
           coluna logo a seguir a ponta da manga e ve-se onde comeca e acaba o
           tecido. */
        function alturaDaColuna(col) {
          var a = -1, b = -1;
          for (var yc = 0; yc < n; yc++) {
            var kc = (yc * n + col) * 4;
            var tec = fundo ? !fundo[yc * n + col]
                            : (d[kc + 3] > 40 && (d[kc] < 238 || d[kc + 1] < 238 || d[kc + 2] < 238));
            if (tec) { if (a < 0) a = yc; b = yc; }
          }
          return b > a ? [a, b] : null;
        }
        var altD = temD ? alturaDaColuna(Math.round(pd - 0.2 * (pd - td))) : null;
        var altE = temE ? alturaDaColuna(Math.round(pe + 0.2 * (te - pe))) : null;
        var meioAltD = altD ? (altD[0] + 0.55 * (altD[1] - altD[0])) / n : null;
        var meioAltE = altE ? (altE[0] + 0.55 * (altE[1] - altE[0])) / n : null;

        var larguraTronco = null;
        for (var f3 = 0.42; f3 <= 0.68; f3 += 0.04) {
          var l3 = linha(Math.round(y0 + f3 * (y1 - y0)));
          if (l3 && (l3[1] - l3[0]) > 0.35 * largo) {
            var w3 = (l3[1] - l3[0]) / n;
            if (larguraTronco == null || w3 < larguraTronco) larguraTronco = w3;
          }
        }
        if (larguraTronco == null) larguraTronco = 0.45 * largo / n;

        var caixa = { x: x0 / n, y: y0 / n, w: (x1 - x0) / n, h: (y1 - y0) / n,
                      cx: centro, cw: larguraTronco,
                      mfd: mangaFotoDir, mfe: mangaFotoEsq,
                      lmd: larguraMangaDir, lme: larguraMangaEsq,
                      mdd: mangaDirDe, mda: mangaDirAte,
                      med: mangaEsqDe, mea: mangaEsqAte,
                      myd: meioAltD, mye: meioAltE };
        medidas[fonte] = caixa;
        quandoPronto(caixa);
      } catch (e) { /* sem CORS fica-se com a posicao por omissao */ }
    };
    teste.src = fonte.replace(/width=\d+/, 'width=300');
  }

  function fotoDasCostas(scope) {
    return fotoDaGaleria(scope, 'back', '__1.');
  }

  /* Camisola escura pede letras brancas, camisola clara pede letras escuras.
     Olha-se para o meio das costas, que e onde o nome vai ficar. */
  function escolherCor(img, camada) {
    var fonte = img.currentSrc || img.src || '';
    if (!fonte) return;
    var url = fonte.replace(/width=\d+/, 'width=200');
    var teste = new Image();
    teste.crossOrigin = 'anonymous';
    teste.onload = function () {
      try {
        var lado = 100;
        var c = document.createElement('canvas');
        c.width = c.height = lado;
        var ctx = c.getContext('2d');
        ctx.drawImage(teste, 0, 0, lado, lado);
        var d = ctx.getImageData(Math.round(lado * 0.38), Math.round(lado * 0.30),
                                 Math.round(lado * 0.24), Math.round(lado * 0.25)).data;
        var r = 0, g = 0, b = 0, n = d.length / 4;
        for (var k = 0; k < d.length; k += 4) { r += d[k]; g += d[k + 1]; b += d[k + 2]; }
        var lum = (0.2126 * r + 0.7152 * g + 0.0722 * b) / n;
        camada.classList.toggle('mvn-costas__camada--escura', lum >= 140);
      } catch (e) { /* imagem de outro dominio: fica no branco, que e o comum */ }
    };
    teste.src = url;
  }

  /* O emblema escolhido na manga da fotografia de frente. As camisolas estao
     todas fotografadas da mesma maneira — a camisola ocupa x 0.17–0.83 e os
     ombros ficam a 0.23–0.77 —, por isso a manga cai sempre no mesmo sitio. */
  /* O ajuste a mao de cada camisola, escrito no bloco dos emblemas pelo
     snippet. Vive aqui em cima porque **duas** funcoes precisam dele — a que
     monta as mangas e a que veste o emblema na fotografia. Enquanto era uma
     variavel dentro do `montarManga`, a segunda rebentava com
     «ajuste is not defined» e levava atras a personalizacao toda. */
  function ajusteDe(scope) {
    try {
      var cx = scope.querySelector('[data-mvn-badges][data-ajuste]');
      if (cx) return JSON.parse(cx.getAttribute('data-ajuste')) || {};
    } catch (e) {}
    return {};
  }

  function montarManga(scope) {
    var img = fotoDaGaleria(scope, 'front', '__0.');
    if (!img) return null;
    var caixa = img.closest('.product-single__media') || img.parentElement;
    if (!caixa) return null;
    var ja = caixa.querySelector('.mvn-manga');
    if (ja) {
      return { direita: caixa.querySelector('.mvn-manga--direita'),
               esquerda: caixa.querySelector('.mvn-manga--esquerda'),
               peito: caixa.querySelector('.mvn-peito') };
    }
    caixa.classList.add('mvn-costas');
    // uma caixa por sitio: manga direita, manga esquerda e peito
    var mD = document.createElement('div');
    mD.className = 'mvn-manga mvn-manga--direita';
    caixa.appendChild(mD);
    var mE = document.createElement('div');
    mE.className = 'mvn-manga mvn-manga--esquerda';
    caixa.appendChild(mE);
    var peito = document.createElement('div');
    peito.className = 'mvn-manga mvn-peito';
    caixa.appendChild(peito);
    /* Nada de percentagens fixas da fotografia: cada emblema segue a camisola
       medida. A manga direita de quem veste aparece a esquerda da imagem. */
    /* Ajuste a mao, camisola a camisola: o que estiver no campo
       `shirt.badge_pos` manda mais do que a medicao da fotografia. Serve para
       as camisolas em que a medida automatica nao acerta. */
    var ajuste = ajusteDe(scope);
    function aMao(sitio) { return ajuste && ajuste[sitio] ? ajuste[sitio] : null; }

    medirCamisola(img, function (b) {
      var larguraP = 0.10 * b.w;
      var meioCorpo = b.cx == null ? b.x + b.w / 2 : b.cx;
      var xDireita = b.mfe == null ? b.x + 0.15 * b.w : b.mfe;
      var xEsquerda = b.mfd == null ? b.x + 0.85 * b.w : b.mfd;
      // o emblema nunca maior do que a manga onde vai
      /* O emblema ocupa cerca de dois tercos da manga — como na camisola a
         serio — e **fica preso dentro dela**: se o meio calculado o deixasse
         com uma ponta de fora, empurra-se para dentro. */
      // o emblema enche a manga: e assim que se ve nas camisolas a serio
      var larguraD = Math.min(0.17 * b.w, 1.0 * (b.lme || 0.12 * b.w));
      var larguraE = Math.min(0.17 * b.w, 1.0 * (b.lmd || 0.12 * b.w));
      function prender(centro, meia, de, ate) {
        if (de == null || ate == null) return centro;
        return Math.min(Math.max(centro, de + meia), ate - meia);
      }
      xDireita = prender(xDireita, larguraD / 2, b.med, b.mea);
      xEsquerda = prender(xEsquerda, larguraE / 2, b.mdd, b.mda);
      var aD = aMao('manga_direita'), aE = aMao('manga_esquerda'), aP = aMao('peito');
      if (aD) { xDireita = aD.x; larguraD = aD.largura; }
      if (aE) { xEsquerda = aE.x; larguraE = aE.largura; }
      mD.style.left = ((xDireita - larguraD / 2) * 100) + '%';
      mE.style.left = ((xEsquerda - larguraE / 2) * 100) + '%';
      var altoD = aD ? aD.y - larguraD / 2
                     : (b.mye != null ? b.mye - larguraD / 2 : b.y + 0.33 * b.h);
      var altoE = aE ? aE.y - larguraE / 2
                     : (b.myd != null ? b.myd - larguraE / 2 : b.y + 0.33 * b.h);
      mD.style.top = (altoD * 100) + '%';
      mE.style.top = (altoE * 100) + '%';
      mD.style.width = (larguraD * 100) + '%';
      mE.style.width = (larguraE * 100) + '%';
      if (aP) { meioCorpo = aP.x; larguraP = aP.largura; }
      peito.style.left = ((meioCorpo - larguraP / 2) * 100) + '%';
      peito.style.top = ((aP ? aP.y - larguraP / 2 : b.y + 0.20 * b.h) * 100) + '%';
      peito.style.width = (larguraP * 100) + '%';
    });
    return { direita: mD, esquerda: mE, peito: peito };
  }

  function montarPreview(scope, raiz) {
    /* 21/08/2026 — nas camisolas da NBA nao se desenha o nome nas costas: as
       costas delas nao sao lisas (riscas, numeros grandes) e o nome por cima
       nao se le nem corresponde ao que sai estampado. Quem decide e o Liquid,
       pela etiqueta `nba-team:`, e diz-nos por `data-costas="0"`. Se o atributo
       nao existir (paginas antigas), desenha-se — como sempre se fez. */
    if (raiz && raiz.dataset && raiz.dataset.costas === '0') return null;
    var img = fotoDasCostas(scope);
    if (!img) return null;
    var caixa = img.closest('.product-single__media') || img.parentElement;
    if (!caixa) return null;
    if (caixa.querySelector('.mvn-costas__camada')) {
      return caixa.querySelector('.mvn-costas__camada');
    }
    caixa.classList.add('mvn-costas');
    var camada = document.createElement('div');
    camada.className = 'mvn-costas__camada';
    camada.innerHTML = '<span class="mvn-costas__nome"></span>' +
                       '<span class="mvn-costas__numero"></span>';
    caixa.appendChild(camada);

    var medida = null;
    /* 23/08 — reparo dele: «numeros e o nome nao estao bem centrados na
       camisola». No computador estavam (medido: 1 px), mas a conta usava a
       largura da **caixa** e as medidas (`cx`, `y`, `h`) sao fraccoes da
       **fotografia**. Enquanto a foto enche a caixa da na mesma; quando nao
       enche — e no telemovel a galeria e um carrossel, com a foto centrada
       dentro da celula — o nome desloca-se para o lado e o tamanho da letra
       fica errado.
       Passa a medir-se a propria fotografia e a somar-se o desvio dela dentro
       da caixa. Quando a foto enche a caixa, as contas dao exactamente o mesmo
       que davam antes. */
    function moldura() {
      var ri = img.getBoundingClientRect();
      var rc = caixa.getBoundingClientRect();
      if (!ri.width || !rc.width) return null;
      return { l: ri.width, alt: ri.height,
               dx: ri.left - rc.left, dy: ri.top - rc.top,
               lc: rc.width };
    }
    function dimensionar() {
      var m = moldura();
      var l = m ? m.l : (caixa.clientWidth || 0);
      camada.style.fontSize = l + 'px';       // o resto e em `em`, no CSS
      if (!medida) return;
      // com a camisola medida, o nome e o numero seguem-na em vez de seguirem
      // a moldura da fotografia — e o que faz isto servir tambem as seleccoes
      var b = medida;
      var meioTexto = m ? m.lc / 2 : l / 2;   // onde o texto cai por si
      var dx = m ? m.dx : 0, dy = m ? m.dy : 0;
      var alt = m ? m.alt : l;
      camada.style.paddingTop = (dy + (b.y + 0.215 * b.h) * alt) + 'px';
      camada.style.transform = 'translateX(' +
        (dx + (b.cx == null ? b.x + b.w / 2 : b.cx) * l - meioTexto) + 'px)';
      var elN = camada.querySelector('.mvn-costas__nome');
      var elNum = camada.querySelector('.mvn-costas__numero');
      var tamanhoNome = 0.064 * b.h * l;
      elNum.style.fontSize = (0.30 * b.h * l) + 'px';

      /* Um nome comprido tem de caber nas costas sem ficar minusculo. Na
         estampagem a serio faz-se por esta ordem: **primeiro aperta-se o
         espaco entre as letras**, que num nome curto e largo de proposito, e
         so depois se encolhe a letra. Assim `ABCDEFGHIJKLMNO` continua a
         ler-se grande, em vez de sair uma linha de formigas. */
      var texto = elN.textContent || '';
      var espaco = texto.length > 8
        ? Math.max(0.05, 0.18 - (texto.length - 8) * 0.019)
        : 0.18;
      elN.style.letterSpacing = espaco + 'em';
      elN.style.textIndent = (espaco / 2) + 'em';   // metade, para ficar ao meio
      elN.style.fontSize = tamanhoNome + 'px';

      var limite = (b.cw || 0.45 * b.w) * l * 0.95;
      var largura = elN.getBoundingClientRect().width;
      if (largura > limite && limite > 0) {
        elN.style.fontSize = (tamanhoNome * limite / largura) + 'px';
      }
    }
    dimensionar();
    camada.ajustar = dimensionar;      // o texto muda: e preciso medir outra vez
    medirCamisola(img, function (b) {
      medida = b;
      // fica escrito no proprio elemento: serve para conferir a medicao sem
      // andar a adivinhar quando uma camisola sai torta
      try { camada.dataset.mvnMedida = JSON.stringify(b); } catch (e) {}
      dimensionar();
    });
    /* a propria fotografia tambem tem de ser vigiada: no carrossel do
       telemovel a celula pode nao mudar de tamanho e a foto mudar */
    if (window.ResizeObserver) {
      var vigia = new ResizeObserver(dimensionar);
      vigia.observe(caixa);
      vigia.observe(img);
    } else window.addEventListener('resize', dimensionar);

    if (img.complete) escolherCor(img, camada);
    img.addEventListener('load', function () { escolherCor(img, camada); });
    return camada;
  }

  /* -------------------------------------------------- badges a escolher ---
     Cada quadrado e um emblema. O cliente pode levar mais do que um, mas so
     dentro da mesma familia: ou os do campeonato, ou os europeus. A regra nao
     esta escrita aqui — sai dos proprios valores da opcao `Badge`, que so
     tem as combinacoes que existem.                                        */

  function emblemasDoValor(valor) {
    var texto = String(valor || '').split(' (+')[0];
    if (!texto || texto === CFG.valBadge[0] || texto === 'No Badge') return [];
    return texto.split(' + ');
  }

  function mesmoConjunto(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (b.indexOf(a[i]) < 0) return false;
    return true;
  }

  function ligarBadges(scope, aoMudar) {
    /* **So se liga uma vez por bloco.** O snippet e desenhado duas vezes (uma
       para os campos, outra para os emblemas), e o `arrancar()` percorre os
       dois — sem esta trava ficavam dois tratadores presos ao mesmo sitio: o
       primeiro juntava o emblema ao campo e o segundo, a ler o campo ja
       mudado, encontrava-o la e tirava-o outra vez. O cliente carregava no
       segundo emblema e via o primeiro desaparecer. */
    if (scope.__mvnBadgesLigado) return;
    scope.__mvnBadgesLigado = true;
    var caixa = scope.querySelector('[data-mvn-badges]');
    var sel = scope.querySelector('select[name="options[' + CFG.optBadge + ']"]');
    if (!caixa || !sel) return;
    var sitios = montarManga(scope);
    var ajuste = ajusteDe(scope);

    /* Dois formatos, porque a loja tem 2 250 camisolas e nao passam todas ao
       mesmo tempo:

       'contagem' (novo) — a variante diz **quantos** emblemas vao (`1 Badge`,
         `2 Badges`) e os nomes vao numa linha de texto da encomenda. Os
         quadrados vem do campo `shirt.badges` do produto, cada um com o seu
         grupo, e e do grupo que sai a regra: o da liga e o de campeao andam
         juntos, tudo o resto anda sozinho.
       'valores' (antigo) — a variante diz **quais**, e as combinacoes validas
         sao os proprios valores da opcao.

       No formato novo a escolha vive aqui, nesta variavel: o tema reescreve o
       bloco a cada mudanca de variante e levava a linha de texto atras. */
    /* ------------------------------------------------------------------
       A escolha dos emblemas vive no **proprio campo da encomenda**
       (`properties[Badges]`), nao numa variavel deste programa.

       Porque: o tema volta a desenhar o bloco dos emblemas de cada vez que a
       variante muda, e uma variavel nascia a zero a cada redesenho. O campo
       escondido esta na outra metade do snippet, a dos campos, que **nao** e
       redesenhada — por isso e o unico sitio que aguenta. Lendo dele, a
       escolha nunca se perde, e o campo e a variante passam a ser escritos
       sempre ao mesmo tempo, pela mesma funcao: se a variante diz `1 Badge`,
       o nome do emblema esta la; se diz `2 Badges`, estao os dois nomes.
       ------------------------------------------------------------------ */
    function lerCampo() {
      var p = propBadges();
      if (!p || !p.value) return [];
      return p.value.split(',').map(function (t) { return t.replace(/^\s+|\s+$/g, ''); })
                    .filter(function (t) { return t.length > 0; });
    }
    function escreverCampo(lista) {
      var p = propBadges();
      if (!p) return;
      p.value = lista.join(', ');
      p.disabled = lista.length === 0;   // vazio nao vai, para nao criar linha em branco
    }

    function modoContagem() {
      var c = scope.querySelector('[data-mvn-badges]');
      return !!(c && c.getAttribute('data-modo') === 'contagem');
    }
    function propBadges() { return scope.querySelector('[data-mvn-badges-prop]'); }
    function lista() { return scope.querySelector('[data-mvn-lista]'); }
    /* O bloco dos emblemas aparece **duas vezes** na pagina: no formulario e
       na barra fixa de comprar, a que aparece no telemovel e no tablet ao
       descer a pagina. Enquanto isto abria so a primeira lista, quem carregava
       em «Add a badge» na barra fixa nao via acontecer nada — os quadrados
       abriam-se la em cima, fora do ecra. Abrem-se agora **todas**. */
    function mostrarLista(sim) {
      var ls = scope.querySelectorAll('[data-mvn-lista]');
      for (var k = 0; k < ls.length; k++) ls[k].hidden = !sim;
      var bs = scope.querySelectorAll('[data-mvn-badge-modo]');
      for (var i = 0; i < bs.length; i++) {
        bs[i].classList.toggle('is-active', (bs[i].dataset.mvnBadgeModo === 'sim') === !!sim);
      }
    }
    /* Os quadrados aparecem duas vezes no HTML — o snippet e desenhado duas
       vezes, uma para os campos e outra para os emblemas —, por isso conta-se
       sempre por **nomes distintos**, nunca pelo numero de quadrados. */
    function nomesDaCamisola() {
      var f = fichaAgora(), out = [];
      for (var i = 0; i < f.length; i++) if (out.indexOf(f[i].nome) < 0) out.push(f[i].nome);
      return out;
    }

    function fichaAgora() {
      var qs = quadradosAgora(), out = [];
      for (var i = 0; i < qs.length; i++) {
        out.push({ nome: qs[i].dataset.badge, grupo: qs[i].dataset.grupo,
                   substitui: qs[i].dataset.substitui === '1' });
      }
      return out;
    }
    function valorPara(n) {
      var s = selectorAgora();
      for (var i = 0; i < s.options.length; i++) {
        var v = s.options[i].value;
        if (contagemDoTexto(v) === n) return v;
      }
      return null;
    }
    function contagemDoValor(v) { return contagemDoTexto(v); }
    function aplicarEscolha(conjunto) {
      /* O nome vai para o campo **antes** de mexer na variante: se algo falhar
         a meio, fica um nome a mais e nunca um `1 Badge` sem nome. */
      escreverCampo(conjunto);
      var s = selectorAgora(), valor = valorPara(conjunto.length);
      if (valor !== null && s.value !== valor) {
        s.value = valor;
        s.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    /* O tema volta a desenhar este bloco de cada vez que a variante muda, por
       isso nada de guardar os quadrados: procuram-se sempre de novo, e o
       clique fica preso ao contentor, que esse nao desaparece. */
    function quadradosAgora() {
      return scope.querySelectorAll('.mvn-perso__badge[data-badge]');
    }
    function selectorAgora() {
      return scope.querySelector('select[name="options[' + CFG.optBadge + ']"]') || sel;
    }
    function combinacoesAgora() {
      if (!modoContagem()) {
        var s = selectorAgora(), out = [];
        for (var i = 0; i < s.options.length; i++) {
          out.push({ valor: s.options[i].value, emblemas: emblemasDoValor(s.options[i].value) });
        }
        return out;
      }
      /* No formato novo as combinacoes nao estao escritas em lado nenhum:
         calculam-se. Cada emblema sozinho; e o par liga + campeao, quando o de
         campeao nao e daqueles que **substituem** o da liga. */
      var f = fichaAgora(), r = [{ valor: valorPara(0), emblemas: [] }];
      for (var i = 0; i < f.length; i++) r.push({ valor: valorPara(1), emblemas: [f[i].nome] });
      for (i = 0; i < f.length; i++) {
        /* 19/08: nas seleccoes o emblema da prova nao e de "liga" mas de
           "torneio" (o do Mundial 2026), e por isso o par com o de campeao nao
           era gerado — na Espanha so se conseguia escolher um dos dois. Ambos
           os grupos contam como "o emblema da prova". */
        if (f[i].grupo !== 'liga' && f[i].grupo !== 'torneio') continue;
        for (var j = 0; j < f.length; j++) {
          if (f[j].grupo !== 'campeao' || f[j].substitui) continue;
          r.push({ valor: valorPara(2), emblemas: [f[i].nome, f[j].nome] });
        }
      }
      return r;
    }
    function procurar(conjunto) {
      var c = combinacoesAgora();
      for (var i = 0; i < c.length; i++) {
        if (mesmoConjunto(c[i].emblemas, conjunto)) return c[i].valor;
      }
      return null;
    }

    function contemTodos(lista, pedidos) {
      for (var i = 0; i < pedidos.length; i++) if (lista.indexOf(pedidos[i]) < 0) return false;
      return true;
    }

    /* Ao juntar um emblema nem sempre ha combinacao com aquele conjunto
       exacto — ha emblemas que so existem acompanhados. Entao escolhe-se a
       combinacao que traz o emblema pedido e que guarda o mais possivel do que
       ja estava escolhido. Desde 18/08 o de campeao da liga tambem anda
       sozinho, e e essa a combinacao que ganha quando se carrega nele
       primeiro; carregar depois no da liga junta os dois. */
    function melhorAoJuntar(conjunto, obrigatorio) {
      var c = combinacoesAgora(), melhor = null, pontosMelhor = -1e9;
      for (var i = 0; i < c.length; i++) {
        var e = c[i].emblemas;
        if (e.indexOf(obrigatorio) < 0) continue;
        var comuns = 0;
        for (var j = 0; j < e.length; j++) if (conjunto.indexOf(e[j]) >= 0) comuns++;
        var pontos = comuns * 10 - (e.length - comuns) - (conjunto.length - comuns) * 3;
        if (pontos > pontosMelhor) { pontosMelhor = pontos; melhor = c[i]; }
      }
      return melhor;
    }

    /* Ao tirar um emblema fica-se com a maior combinacao que caiba dentro do
       que sobrou. */
    function melhorAoTirar(conjunto) {
      var c = combinacoesAgora(), melhor = null, tamanho = -1;
      for (var i = 0; i < c.length; i++) {
        if (!contemTodos(conjunto, c[i].emblemas)) continue;
        if (c[i].emblemas.length > tamanho) { tamanho = c[i].emblemas.length; melhor = c[i]; }
      }
      return melhor;
    }
    function escolhidos() {
      return modoContagem() ? lerCampo() : emblemasDoValor(selectorAgora().value);
    }

    /* Cada emblema vai para onde se usa mesmo: o da liga e o da Champions na
       manga, o de campeao nacional (Portugal, Italia, Brasil, Alemanha) ao
       peito, entre o emblema do clube e o patrocinador. */
    /* Cada emblema vai para o sitio que o catalogo diz: manga direita, manga
       esquerda, as duas (Inglaterra) ou peito. */
    /* **So se desenha o emblema na fotografia quando ha ajuste a mao para
       aquela camisola.** A medida automatica acerta em muitas mas falha noutras
       tantas — as fotografias vem de 40 lojas diferentes, umas de corpo
       inteiro, outras so do tronco — e um emblema meio fora da manga fica pior
       do que nao ter emblema nenhum. Onde nao houver ajuste, o cliente ve na
       mesma o quadrado com o visto verde. */
    function limparMangas() {
      if (!sitios) return;
      sitios.direita.innerHTML = '';
      sitios.esquerda.innerHTML = '';
      sitios.peito.innerHTML = '';
      sitios.direita.classList.remove('is-ligada');
      sitios.esquerda.classList.remove('is-ligada');
      sitios.peito.classList.remove('is-ligada');
    }

    /* 21/08/2026, por decisao do dono: **no telemovel nao se desenha o emblema
       na camisola.** O ajuste a mao foi medido no ecra grande; na fotografia
       pequena do telemovel o emblema sai descentrado, e um emblema fora do
       sitio e pior do que nao ter emblema nenhum. O quadrado com o visto fica
       na mesma — o cliente escolhe como sempre, so nao ve a montagem. */
    function ecraPequeno() {
      return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
    }

    function vestirManga(actuais) {
      if (!sitios) return;
      if (ecraPequeno()) { limparMangas(); return; }
      if (!ajuste || !(ajuste.manga_direita || ajuste.manga_esquerda || ajuste.peito)) {
        sitios.direita.innerHTML = '';
        sitios.esquerda.innerHTML = '';
        sitios.peito.innerHTML = '';
        sitios.direita.classList.remove('is-ligada');
        sitios.esquerda.classList.remove('is-ligada');
        sitios.peito.classList.remove('is-ligada');
        return;
      }
      var quadrados = quadradosAgora();
      sitios.direita.innerHTML = '';
      sitios.esquerda.innerHTML = '';
      sitios.peito.innerHTML = '';
      for (var i = actuais.length - 1; i >= 0; i--) {
        for (var j = 0; j < quadrados.length; j++) {
          if (quadrados[j].dataset.badge !== actuais[i]) continue;
          var origem = quadrados[j].querySelector('img');
          if (!origem) continue;
          var onde = [];
          if (quadrados[j].dataset.posicao === 'peito') onde = [sitios.peito];
          else if (quadrados[j].dataset.lado === 'ambas') onde = [sitios.direita, sitios.esquerda];
          else if (quadrados[j].dataset.lado === 'esquerda') onde = [sitios.esquerda];
          else onde = [sitios.direita];
          for (var k = 0; k < onde.length; k++) {
            var copia = document.createElement('img');
            copia.src = origem.src;
            copia.alt = '';
            onde[k].appendChild(copia);
          }
          break;
        }
      }
      sitios.direita.classList.toggle('is-ligada', sitios.direita.children.length > 0);
      sitios.esquerda.classList.toggle('is-ligada', sitios.esquerda.children.length > 0);
      sitios.peito.classList.toggle('is-ligada', sitios.peito.children.length > 0);
    }

    function pintar(forcar) {
      var actuais = escolhidos(), quadrados = quadradosAgora();
      if (modoContagem()) {
        var s2 = selectorAgora();
        var pedidos = contagemDoValor(s2.value);   // quantos emblemas a variante diz
        /* Se a variante pedir emblemas e nao houver nomes, os dois estao a
           dizer coisas diferentes — e a encomenda sairia com `1 Badge` sem
           dizer qual, que e o buraco que se anda a tapar. Resolve-se sempre a
           favor de haver nome:
             - se a camisola so tem um emblema, `1 Badge` so pode ser esse:
               adopta-se, e o nome fica escrito;
             - se tem varios, nao ha como adivinhar: volta a `No Badge` e o
               cliente escolhe. Nunca se vende um emblema sem nome. */
        if (pedidos > 0 && actuais.length === 0) {
          var nomes = nomesDaCamisola();
          if (pedidos === 1 && nomes.length === 1) actuais = [nomes[0]];
        }
        escreverCampo(actuais);
        var certo = valorPara(actuais.length);
        if (certo !== null && (forcar || contagemDoValor(s2.value) !== actuais.length)) {
          s2.value = certo;
          s2.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      for (var i = 0; i < quadrados.length; i++) {
        var q = quadrados[i], nome = q.dataset.badge;
        var dentro = actuais.indexOf(nome) >= 0;
        var alvo = melhorAoJuntar(actuais.concat([nome]), nome);
        // so nao esta bloqueado se o que ja estava escolhido se mantiver
        var junta = !!alvo && contemTodos(alvo.emblemas, actuais);
        q.classList.toggle('is-active', dentro);
        q.classList.toggle('is-bloqueado', !dentro && !junta);
        q.setAttribute('aria-pressed', dentro ? 'true' : 'false');
        q.title = dentro ? nome + ' — carregue para tirar'
                : junta ? nome + ' — carregue para juntar'
                        : nome + ' — nao se usa ao mesmo tempo; carregue para trocar';
      }
      var caixaAgora = scope.querySelector('[data-mvn-badges]');
      if (caixaAgora) caixaAgora.classList.add('mvn-perso__badges--soltos');
      // depois de o tema redesenhar o bloco, a lista nasce fechada: reabre-se
      // se ja houver emblema escolhido
      if (lista()) mostrarLista(actuais.length > 0 || !lista().hidden);
      /* Com os quadrados a mandar, a caixa de escolha do tema esta a mais —
         e nao so a do formulario: a barra fixa de comprar tem a sua propria
         (`options[Badge--sticky]`). Deixa-la a vista era deixar um caminho
         para `1 Badge` sem dizer qual, que e o buraco de 20/08. */
      var todosSel = scope.querySelectorAll('select[name^="options[' + CFG.optBadge + '"]');
      for (var z = 0; z < todosSel.length; z++) {
        var emb = todosSel[z].closest('.select') || todosSel[z].parentElement;
        if (emb) emb.classList.add('mvn-escondido');
      }
      var total = scope.querySelector('[data-mvn-total]');
      if (total) {
        var n = actuais.length;
        total.hidden = n === 0;
        /* 19/08: o total estava a ser escrito com `€2.99` fixo no programa —
           um cliente ingles via a camisola em libras e o emblema em euros. Os
           valores vem agora do proprio snippet (`data-extra1`/`data-extra2`),
           que os escreve com o formatador da loja e por isso ja convertidos. */
        var caixaTotal = scope.querySelector('[data-mvn-badges]');
        var texto = caixaTotal ? caixaTotal.dataset['extra' + n] : null;
        total.textContent = n === 0 ? '' :
          actuais.join(', ') + (texto ? '  —  +' + texto : '');
      }
      vestirManga(actuais);
    }

    /* A garantia deste bloco: se a variante manda pagar emblemas e o campo
       esta vazio, escreve-se o nome — dos quadrados marcados, ou do unico
       emblema da camisola quando so ha um. */
    garantias.push(function () {
      if (!modoContagem()) return;
      if (lerCampo().length) return;
      var pedidos = contagemDoValor(selectorAgora().value);
      if (pedidos <= 0) return;
      var marcados = [], qs = quadradosAgora();
      for (var i = 0; i < qs.length; i++) {
        var n = qs[i].dataset.badge;
        if (qs[i].classList.contains('is-active') && marcados.indexOf(n) < 0) marcados.push(n);
      }
      if (!marcados.length) {
        var nomes = nomesDaCamisola();
        if (pedidos === 1 && nomes.length === 1) marcados = [nomes[0]];
      }
      if (marcados.length) escreverCampo(marcados);
    });

    /* Primeiro passo: leva emblema ou nao. Dizer que nao limpa o que estivesse
       escolhido; dizer que sim so abre a lista — so se paga quando se escolhe
       mesmo um emblema. */
    scope.addEventListener('click', function (e) {
      var m = e.target.closest ? e.target.closest('[data-mvn-badge-modo]') : null;
      if (!m || !scope.contains(m)) return;
      e.preventDefault();
      var sim = m.dataset.mvnBadgeModo === 'sim';
      if (!sim && escolhidos().length) aplicarEscolha([]);
      mostrarLista(sim);
      pintar();
      if (aoMudar) aoMudar();
    });

    scope.addEventListener('click', function (e) {
      var q = e.target.closest ? e.target.closest('.mvn-perso__badge[data-badge]') : null;
      if (!q || !scope.contains(q)) return;
      e.preventDefault();
      var nome = q.dataset.badge, actuais = escolhidos(), alvo = null;
      if (actuais.indexOf(nome) >= 0) {
        var fica = actuais.filter(function (x) { return x !== nome; });
        alvo = melhorAoTirar(fica) || { valor: valorPara(0), emblemas: [] };
      } else {
        alvo = melhorAoJuntar(actuais.concat([nome]), nome);
      }
      if (!alvo || alvo.valor === null) return;
      if (modoContagem()) {
        aplicarEscolha(alvo.emblemas);
      } else {
        var s = selectorAgora();
        s.value = alvo.valor;
        s.dispatchEvent(new Event('change', { bubbles: true }));
      }
      pintar();
      if (aoMudar) aoMudar();
    });

    scope.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'options[' + CFG.optBadge + ']') pintar();
    });

    // o tema reescreve o bloco: repinta-se quando isso acontecer
    if (window.MutationObserver) {
      var pendente = null;
      new MutationObserver(function () {
        clearTimeout(pendente);
        pendente = setTimeout(pintar, 60);
      }).observe(scope, { childList: true, subtree: true });
    }
    pintar();
    /* Quem chega por um endereco de variante com emblemas (`?variant=...`)
       encontra a pagina com o preco dos emblemas mas sem nenhum escolhido. O
       `pintar` poe a variante de acordo com o que esta escolhido — mas se
       correr antes de o tema estar pronto, o preco nao acompanha. Repete-se
       duas vezes, ja com o tema a ouvir. */
    setTimeout(function () { pintar(true); }, 300);
    setTimeout(function () { pintar(true); }, 900);
  }

  function ligar(raiz) {
    if (raiz.dataset.mvnLigado) return;
    raiz.dataset.mvnLigado = '1';
    // primeiro de tudo: em que lingua estao os nomes das opcoes desta pagina
    try { lerCfg(raiz); } catch (e) {}

    /* 21/08/2026 — o bloco da gaveta da vista rapida nao tem `.product-information`
       nem `<form>` por cima, por isso caia no `document`: e ali agarrava a caixa
       de emblemas **da pagina de produto que estava por baixo**. Carregar num
       emblema dentro da gaveta nao fazia nada visivel e mexia no produto de tras
       — e o preco nunca subia, ou seja, dois emblemas pelo preco de um.
       A gaveta entra como alternativa, **depois** do `.product-information`: se
       se estreitasse o ambito da pagina de produto, o `montarPreview` deixava de
       encontrar a fotografia das costas, que vive fora do bloco do formulario. */
    var scope = raiz.closest('.product-information')
             || raiz.closest('.product-drawer')
             || raiz.closest('.side-panel')
             || raiz.closest('.product-information--inner')
             || raiz.closest('form')
             || document;
    /* Cada pedaco corre dentro da sua propria rede. Um erro num deles — a
       fotografia, os emblemas, os precos — nao pode levar atras o que importa
       mesmo: o cliente conseguir escolher o jogador ou escrever o nome. */
    try { precosNoMenu(raiz); } catch (e) {}   // "+£2.60" ao lado de cada escolha
    var campos = raiz.querySelectorAll('[data-when]');
    var botoes = scope.querySelectorAll('.mvn-perso__badge');
    var semPlantel = raiz.dataset.plantel === '0';
    var aviso = raiz.querySelector('[data-mvn-aviso]');
    var camada = null;
    try { camada = montarPreview(scope, raiz); } catch (e) {}

    function escrever(nome, numero) {
      if (!camada) return;
      var elN = camada.querySelector('.mvn-costas__nome');
      var elNum = camada.querySelector('.mvn-costas__numero');
      elN.textContent = nome || '';
      elNum.textContent = numero || '';
      if (camada.ajustar) camada.ajustar();
      var mostra = !!(nome || numero);
      camada.classList.toggle('is-ligada', mostra);
      if (aviso) aviso.hidden = !mostra;
    }

    function actualizar() {
      var escolha = valorDaOpcao(scope, CFG.optNome);
      for (var i = 0; i < campos.length; i++) {
        var campo = campos[i];
        var quando = campo.dataset.when;
        var ligado = /^\d+$/.test(quando)
              ? escolha === CFG.valNome[parseInt(quando, 10)]
              : escolha.indexOf(quando) === 0;
        campo.hidden = !ligado;
        var inputs = campo.querySelectorAll('input, select');
        for (var j = 0; j < inputs.length; j++) {
          inputs[j].disabled = !ligado;
          if (inputs[j].dataset.mvnObrigatorio === '1') inputs[j].required = ligado;
        }
      }
      var badge = valorDaOpcao(scope, CFG.optBadge);
      for (var k = 0; k < botoes.length; k++) {
        botoes[k].classList.toggle('is-active', botoes[k].dataset.value === badge);
      }

      if (escolha === CFG.valNome[1]) {
        var sel = raiz.querySelector('select[name="properties[Player]"]');
        var p = partirEtiqueta(sel && sel.value);
        escrever(p.nome, p.numero);
      } else if (escolha === CFG.valNome[2]) {
        var iN = raiz.querySelector('input[name="properties[Name]"]');
        var iNum = raiz.querySelector('input[name="properties[Number]"]');
        escrever(iN ? iN.value : '', iNum ? iNum.value : '');
      } else {
        escrever('', '');
      }
    }

    // Sem plantel gravado nao faz sentido oferecer "Select player".
    if (semPlantel) {
      /* 25/08/2026 — **nao se tira a opcao do menu, desliga-se.**
         Tirar a <option> fazia o `product.js` do tema rebentar no
         `setDisabled()` («Cannot set properties of null»): ele procura
         `option[value=...]` para cada valor da variante e encontrava nada. Com
         a excepcao a meio, o «Add to cart» ficava desactivado **desde que a
         pagina abria** — nas 25 femininas e em toda a seleccao sem plantel.
         Desligada e marcada, o menu continua completo para o tema e o
         `mvn-produto.js` esconde o botao correspondente. */
      var selsNome = scope.querySelectorAll('select[name^="options[' + CFG.optNome + '"]');
      for (var s = 0; s < selsNome.length; s++) {
        var ops = selsNome[s].options;
        for (var o = 0; o < ops.length; o++) {
          if (ops[o].value === CFG.valNome[1]) {
            ops[o].disabled = true;
            ops[o].dataset.mvnEscondido = '1';
          }
        }
        if (selsNome[s].mvnSincronizar) selsNome[s].mvnSincronizar();
      }
    }

    /* ------------------------------------------------------------------
       MOSTRAR AS COSTAS AO PERSONALIZAR — 20/08/2026
       No telemovel a galeria e um carrossel: a frente esta a vista e as costas
       ficam fora do ecra, a direita. O cliente escrevia o nome e nao via nada a
       acontecer. Assim que ele escolhe personalizar, a galeria desliza sozinha
       para as costas, que e onde o nome aparece.

       **So se faz isto quando ele muda de opcao**, nao a cada letra: se depois
       ele arrastar a galeria para outra fotografia, fica onde a deixou.
       ------------------------------------------------------------------ */
    var jaMostrouCostas = false;
    function correParaAsCostas() {
      var galeria = document.querySelector('product-slider, .product-images');
      if (!galeria) return;
      var slides = galeria.querySelectorAll('[data-media-id]');
      /* 21/08/2026 — isto procurava `- back` no fim da legenda. **Nesse mesmo
         dia as legendas passaram a ser traduzidas**, e em portugues a foto das
         costas passou a dizer «- costas», em alemao «- Ruckseite». Resultado:
         em 17 das 18 linguas deixou de encontrar a fotografia e nao corria para
         la — o dono deu por isso no telemovel, mas falhava em toda a parte.
         Agora conhece a palavra nas 19 linguas; e se nenhuma casar (uma legenda
         escrita a mao, por exemplo), fica-se pela **segunda** fotografia, que
         nas camisolas e sempre as costas. */
      var COSTAS = ['back', 'costas', 'trasera', 'arrière', 'retro', 'rückseite',
                    'achterkant', 'tył', 'zadní strana', 'zadná strana', 'bagside',
                    'baksida', 'bakside', 'takapuoli', 'πίσω', 'hátulja', 'spate',
                    'バック'];
      function eAsCostas(alt) {
        var t = (alt || '').toLowerCase().replace(/\s+$/, '').replace(/\s+view$/, '');
        for (var k = 0; k < COSTAS.length; k++) {
          if (t.slice(-COSTAS[k].length) === COSTAS[k]) return true;
        }
        return false;
      }
      var alvo = null;
      for (var i = 0; i < slides.length; i++) {
        var im = slides[i].querySelector('img');
        if (eAsCostas(im && im.alt)) { alvo = slides[i]; break; }
      }
      if (!alvo && slides.length > 1) alvo = slides[1];
      if (!alvo) return;
      // quem rola e o primeiro pai que tenha barra horizontal
      var caixa = alvo.parentElement;
      while (caixa && caixa.scrollWidth <= caixa.clientWidth + 4) caixa = caixa.parentElement;
      if (!caixa) return;
      var destino = alvo.offsetLeft - caixa.offsetLeft;
      try { caixa.scrollTo({ left: destino, behavior: 'smooth' }); }
      catch (e) { caixa.scrollLeft = destino; }
      // rede de seguranca: com o separador escondido as animacoes nao correm
      window.setTimeout(function () {
        if (Math.abs(caixa.scrollLeft - destino) > 4) caixa.scrollLeft = destino;
      }, 420);
    }

    scope.addEventListener('change', function (e) {
      if (!e.target.matches('input, select')) return;
      actualizar();
      // mudou de opcao ou escolheu jogador: mostra-se o que ele vai levar impresso
      var nome = e.target.name || '';
      if (nome.indexOf('options[' + CFG.optNome + ']') === 0 || nome === 'properties[Player]') {
        if (valorDaOpcao(scope, CFG.optNome) !== CFG.valNome[0]) { correParaAsCostas(); jaMostrouCostas = true; }
      }
    });
    raiz.addEventListener('input', function (e) {
      if (e.target.dataset && e.target.dataset.mvnFiltro) limpar(e.target);
      actualizar();                       // escreve nas costas letra a letra
      // a primeira letra tambem leva la o cliente; a partir dai fica onde quiser
      if (!jaMostrouCostas && /properties\[(Name|Number)\]/.test(e.target.name || '')) {
        correParaAsCostas(); jaMostrouCostas = true;
      }
    });
    try { ligarBadges(scope, actualizar); } catch (e) {}
    /* Rodar o telemovel ou mudar o tamanho da janela atravessa os 767px: volta
       a decidir-se se ha montagem ou nao, em vez de ficar como estava. */
    var esperaLargura = null;
    window.addEventListener('resize', function () {
      if (esperaLargura) clearTimeout(esperaLargura);
      esperaLargura = setTimeout(function () { esperaLargura = null; actualizar(); }, 200);
    });
    actualizar();
  }

  function arrancar() {
    var todos = document.querySelectorAll('.mvn-perso');
    for (var i = 0; i < todos.length; i++) { try { ligar(todos[i]); } catch (e) {} }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', arrancar);

  /* 21/08/2026 — a janela «Selecionar opcoes» (a gaveta da vista rapida) e
     enchida por JavaScript do tema **depois** de a pagina carregar, e sem
     disparar `shopify:section:load`. O nosso codigo nunca la corria: o menu do
     emblema ficava a vista (o dono via «dois emblemas», 21/08) e nem o campo do
     jogador nem a caixa do nome respondiam. E nao dava erro nenhum na consola,
     porque as chamadas estao dentro de `try/catch`.
     Por isso ficamos a olhar para o documento: mal apareca um bloco novo,
     liga-se. O `ligar` ja se protege de ser chamado duas vezes
     (`raiz.dataset.mvnLigado`), por isso repetir nao faz mal. */
  if (window.MutationObserver) {
    var pendente = null;
    var vigia = new MutationObserver(function (mudancas) {
      for (var i = 0; i < mudancas.length; i++) {
        var novos = mudancas[i].addedNodes;
        for (var j = 0; j < novos.length; j++) {
          var n = novos[j];
          if (n.nodeType !== 1) continue;
          if ((n.classList && n.classList.contains('mvn-perso')) ||
              (n.querySelector && n.querySelector('.mvn-perso'))) {
            if (pendente) clearTimeout(pendente);
            pendente = setTimeout(function () { pendente = null; arrancar(); }, 60);
            return;
          }
        }
      }
    });
    vigia.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
